export interface LineRect {
  x: number; y: number; width: number; height: number; baseline: number;
}

export function measureLineRects(range: Range): LineRect[] {
  const clientRects = Array.from(range.getClientRects());
  if (clientRects.length === 0) {
    // Empty/whitespace line: synthesize minimal rect
    const r = range.getBoundingClientRect();
    return [{ x: r.x, y: r.y, width: 0, height: r.height || 1, baseline: r.y + (r.height || 1) * 0.8 }];
  }
  // Baseline probe: insert zero-width inline element
  const probe = document.createElement('span');
  probe.style.display = 'inline-block';
  probe.style.width = '0px';
  const end = range.endContainer;
  // const endOffset = range.endOffset; // reserved for future baseline precision
  try {
    const parent = end.nodeType === Node.TEXT_NODE ? end.parentNode : end;
    parent?.insertBefore(probe, (end as any).nextSibling ?? null);
    const baselineY = probe.getBoundingClientRect().bottom;
    return clientRects.map(r => ({ x: r.x, y: r.y, width: r.width, height: r.height, baseline: baselineY }));
  } finally {
    probe.remove();
  }
}

export function measureZeroWidthAnchorRect(el: HTMLElement): DOMRect {
  const probe = document.createElement('span');
  probe.style.display = 'inline-block';
  probe.style.width = '0px';
  el.appendChild(probe);
  const rect = probe.getBoundingClientRect();
  probe.remove();
  return rect;
}


